import React,{useEffect,useState} from "react";
import Header from './Header'
import Footer from './Footer'
import { useLocation } from "react-router-dom";

export default (props) =>{
   
    var location = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location]);
    return (
        <div className={props.className}>
            <Header></Header>
            {props.children}
            <Footer></Footer>
        </div>
    )
}

